import type { ScriptHTMLAttributes } from 'preact/compat';

const TIMEOUT = 5_000;

export function loadScript(url: string, attrs?: ScriptHTMLAttributes<HTMLScriptElement>): Promise<HTMLScriptElement> {
	if (typeof window === 'undefined') {
		throw new Error('loadScript can only be used in the browser');
	}

	return new Promise((resolve, reject) => {
		const script = globalThis.document.createElement('script');
		script.src = url;
		script.async = true;
		script.crossOrigin = 'anonymous';
		if (attrs) {
			Object.assign(script, attrs);
		}
		const listenerOptions: AddEventListenerOptions = {
			once: true,
		};
		const timeoutId = setTimeout(() => {
			script.removeEventListener('load', onLoad);
			script.removeEventListener('error', onError);
			reject(new Error(`Script loading timeout for ${url}`));
		}, TIMEOUT);

		const onLoad = () => {
			clearTimeout(timeoutId);
			script.removeEventListener('error', onError, listenerOptions);

			resolve(script);
		};
		const onError = (error: ErrorEvent) => {
			clearTimeout(timeoutId);
			script.removeEventListener('load', onLoad, listenerOptions);

			reject(new Error(`Script loading error for ${url}: ` + error.message));
		};

		script.addEventListener('load', onLoad, listenerOptions);
		script.addEventListener('error', onError, listenerOptions);

		globalThis.window.document.head.appendChild(script);
	});
}
